import React from "react"
import PropTypes from "prop-types"
import { Text } from "ui/Typography"
import GridEventCell from "../GridEventCell"
import { Tooltip } from "antd"

const GridBodyRows = ({ rows, calendarDays, getVisibleCount, maxVisible, showMore, showLess, openBookingModal, rowClassName, nameCellClassName, eventCellClassName, eventCellInnerClassName, getDayCellClassName }) =>
  rows.map(({ key, label, eventsByDay }) => (
    <tr key={key} className={rowClassName}>
      <td className={nameCellClassName}><Tooltip title={label}><Text>{label}</Text></Tooltip> </td>
      {calendarDays.map((day) => {
        const dayStr = day.format("YYYY-MM-DD")
        const cellKey = `${key}-${dayStr}`
        return (
          <GridEventCell
            key={dayStr}
            cellEvents={eventsByDay[dayStr] || []}
            visibleCount={getVisibleCount(cellKey)}
            maxVisible={maxVisible}
            onShowMore={showMore}
            onShowLess={showLess}
            onBookingClick={openBookingModal}
            cellKey={cellKey}
            tdClassName={`${eventCellClassName || ""} ${getDayCellClassName?.(dayStr) || ""}`.trim()}
            innerClassName={eventCellInnerClassName}
          />
        )
      })}
    </tr>
  ))

GridBodyRows.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    eventsByDay: PropTypes.object.isRequired,
  })).isRequired,
  calendarDays: PropTypes.array.isRequired,
  getVisibleCount: PropTypes.func.isRequired,
  maxVisible: PropTypes.number.isRequired,
  showMore: PropTypes.func.isRequired,
  showLess: PropTypes.func.isRequired,
  openBookingModal: PropTypes.func.isRequired,
  rowClassName: PropTypes.string,
  nameCellClassName: PropTypes.string,
  eventCellClassName: PropTypes.string,
  eventCellInnerClassName: PropTypes.string,
  /** Per-day class on top of `eventCellClassName` — blackout shading uses it. */
  getDayCellClassName: PropTypes.func,
}

export default GridBodyRows
